<template>
  <div>
    <Layout class="member-layout">
      <header class="title">
        成员管理
        <div class="search-panel">
          <p class="icon-panel" v-show='keyword' @click='reloadUser'>
            <i class='clear-input'>✖︎</i>
          </p>
          <Input v-model="keyword" @on-enter="searchUser" @on-change="inputChange" placeholder="搜索名称或ID" class="search-control">
            <Button slot="append" icon="ios-search" @click='searchUser'></Button>
          </Input>
        </div>
      </header>
      <Table border  size='small'  :columns="tableHeader" :data="tableUsers"></Table>
      <Page v-show="totalCount > pageSize" :total="totalCount" size="small" :page-size="pageSize" :current="currentPage" @on-change='changePage($event)' style='margin-top:8px;margin-bottom:8px;'></Page>
    </Layout>
  </div>
</template>
<script>
import api from "../service/api";
import getData from "../service/getData";
import "../assets/stylesheets/member.scss";

export default {
  data () {
    return {
      searchValue: "",
      tableHeader: [],
      tableUsers: [],
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      keyword: "",
      searchPage: 1,
      isSearch: false
    };
  },
  mounted () {
    this.getUser();
    this.createPageControl($('.ivu-page')[0]);
  },
  methods: {
    createPageControl (dom) {
      let leftPage = dom;
      let firstLi = $(leftPage).find(':first-child a');
      firstLi.html('上一页');
      $(leftPage).find(':last-child a').html('下一页');
      let firstPage = document.createElement('li');
      let lastPage = document.createElement('li');
      firstPage.innerHTML = '<a>首页</a>';
      lastPage.innerHTML = '<a>尾页</a>';
      firstPage.className = 'ivu-page-prev';
      lastPage.className = 'ivu-page-next';
      leftPage.insertBefore(firstPage, leftPage.childNodes[0]);
      leftPage.appendChild(lastPage);
      let self = this;
      firstPage.onclick = () => {
        if (self.currentPage === 1) {return;}
        self.changePage(1);
      };
      lastPage.onclick = () => {
        let lastPage = parseInt(self.totalCount / self.pageSize) + 1;
        if (self.currentPage === lastPage) {return;}
        self.changePage(lastPage);
      };
    },
    inputChange () {
      if (!this.keyword && this.isSearch) {
        this.isSearch = !this.isSearch;
        this.reloadUser();
      }
    },
    reloadUser () {
      if (this.isSearch) {
        this.isSearch = !this.isSearch;
        this.refreshAll();
        this.keyword = null;
        this.getUser();
      } else {
        this.keyword = null;
      }

    },
    searchUser: async function () {
      if (!this.keyword || this.keyword.trim().length === 0) {
        this.$Message.error('搜索条件不能为空');
        return false;
      }
      this.isSearch = !this.isSearch;
      let params = {
        key: this.keyword,
        type: 'LianHeLihua'
      };
      let self = this;
      const res = await getData.get(api.usersSearch, params);
      if (res && res.data && res.data.status) {
        self.refreshAll();
        self.setUsers(res.data.users);
      } else {
        console.log(res);
      }
    },
    refreshAll () {
      this.tableHeader = [];
      this.tableUsers = [];
      this.currentPage = 1;
    },
    changePage (page) {
      this.refreshAll();
      this.currentPage = page;
      this.getUser();
    },
    setUsers (users) {
      let count = 0;
      for (let user of users) {
        let obj = {
          name: user.nickname
        };
        for (let key in user.info) {
          count++;
          obj[key] = user.info[key];
        }
        this.tableUsers.push(obj);
      }
      if (count > 5) {
        for (let str in this.tableUsers[0]) {
          this.tableHeader.push({
            title: str,
            key: str,
            align: 'center',
            width: 160
          });
        }
      } else {
        for (let str in this.tableUsers[0]) {
          this.tableHeader.push({
            title: str,
            key: str,
            align: 'center'
          });
        }
      }
    },
    getUser: async function () {
      let params = {
        type: "LianHeLihua",
        pageCount: this.pageSize,
        page: this.currentPage
      };
      const res = await getData.get(api.users, params);
      if (res && res.data && res.data.status) {
        this.totalCount = res.data.allCount;
        this.setUsers(res.data.users);
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Members.vue